module.exports = __webpack_public_path__ + "static/media/cookido.c3dfa1a9.png";